export default "__VITE_ASSET__Dvy_imHR__"